import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppHeader } from '../../components/common';
import { RayForm, RayFormValidation } from '../../components/common';
import { Sitemap, CountryCode } from '../../config';
import { langSelectValue, langSelectOptions } from '../../lib/preLoginLang';
import { resolveStoredUserLangCode, resolveStoredMailLangCode } from '../../config/currentLang';
import { userFieldLabel } from '../admin/userFormFields';
import { UserAction } from '../../actions/UserAction';
import { AlertAction } from '../../actions/AlertAction';
import { store } from '../../store';
import { Loading } from '../../components/common/Loading';
import { Translate as t } from '../../config/Translate';

export const UserInfo = () => {

    const { adminid } = useParams();
    //const [ t, i18n ] = useTranslation();

    const [inputs, setInputs] = useState({});
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        email: "",
        hp: "",
        tel: "",
    });
    const [companyInfo, setCompanyInfo] = useState({
        name: "",
        address: "",
        tel: "",
        fax: "",
        email: "",
    });
    const [countryName, setCountryName] = useState("");
    // 사용자 정보를 읽는 동안 빈 양식·기본 아바타 대신 표시
    const [loading, setLoading] = useState(true);

    const isEditable = false;

    useEffect(() => {
        getUserInfo();
    }, [])

    const getUserInfo = async () => {
        try {
            const usr = await UserAction.getUserInfo(adminid);
            if (usr) {
                setUser(usr);
                setCompanyInfo(usr.companyInfo || {});
            }
        } catch (error) {
            store.dispatch(AlertAction.Error(error));
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setInputs({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            hp: user.hp,
            tel: user.tel && user.tel,
            rguardSettingLanguage: resolveStoredUserLangCode(user) || '',
            rguardSettingEmailReportLanguage: resolveStoredMailLangCode(user),
            companyInfoname: companyInfo.name || "",
            companyInfoaddress: companyInfo.address || "",
            companyInfotel: companyInfo.tel || "",
            companyInfofax: companyInfo.fax || "",
            companyInfoemail: companyInfo.email || "",
        });
        const cName = CountryCode.filter((obj) => { return obj.code == companyInfo.country; });
        if (cName.length)
            setCountryName(cName[0].title);
    }, [user]);

    const form_controls = [
        {
            title: "", items: [
                { type: "input", name: "firstName", label: t('common.field.firstName'), val: inputs.firstName, required: true, isEditable: isEditable },
                { type: "input", name: "lastName", label: t('common.field.lastName'), val: inputs.lastName, required: true, isEditable: isEditable },
            ], editinfo: true
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: inputs.email, required: true, isEditable: isEditable },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: inputs.hp, isEditable: isEditable },
            ], editinfo: true
        },
        {
            title: "", items: [
                { type: "select", name: "rguardSettingLanguage", label: userFieldLabel('rguardSettingLanguage'), val: langSelectValue(inputs.rguardSettingLanguage), list: langSelectOptions(inputs.rguardSettingLanguage), isEditable: isEditable },
                { type: "select", name: "rguardSettingEmailReportLanguage", label: userFieldLabel('rguardSettingEmailReportLanguage'), val: langSelectValue(inputs.rguardSettingEmailReportLanguage), list: langSelectOptions(inputs.rguardSettingEmailReportLanguage), isEditable: isEditable },
            ], editinfo: true
        },
        {
            title: "", items: [
                { type: "select", name: "country", label: t('common.field.country'), val: countryName, list: CountryCode },
                { type: "email", name: "companyInfo.email", label: t('common.field.email'), val: inputs.companyInfoemail },
            ], editinfo: false
        },
        {
            title: "", items: [
                { type: "input", name: "companyInfo.tel", label: t('common.field.tel'), val: inputs.companyInfotel },
                { type: "input", name: "companyInfo.fax", label: t('common.field.fax'), val: inputs.companyInfofax },
            ], editinfo: false
        },
        {
            title: "", items: [
                { type: "input", name: "companyInfo.address", label: t('common.field.address'), val: inputs.companyInfoaddress, size: 12 },
            ], editinfo: false
        },
    ]

    return (
        <>
            <div className="appHeader no-border">
                <AppHeader title={adminid} />
                <div className="right">
                </div>
            </div>
            <div id="appCapsule">
                {loading && <div className="mt-3 text-center"><Loading /></div>}
                {!loading && <>
                <div className="section mt-2 mb-2 text-center">
                    <div className="avatar-section">
                        {user.avatar && <img src={user.avatar} alt="avatar" className="imaged w100 rounded" />}
                        {!user.avatar && <img src="/assets/img/avatar_default_none.png" alt="avatar" className="imaged w100 rounded" />}
                    </div>
                </div>
                <div className="mb-2">
                    <RayForm
                        controls={isEditable ? form_controls.filter(c => c.editinfo) : form_controls}
                        readOnly={!isEditable} />
                </div>
                </>}
            </div>
        </>
    )
}